const localization = {
    "Show log": {
        'ru': 'Показать лог',
        'en': 'Show log',
    },
    "Copy": {
        'ru': 'Копировать',
        'en': 'Copy',
    },
    "To copy": {
        'ru': 'Cкопировать',
        'en': 'Copy',
    },
    "Cancel": {
        'ru': 'Отмена',
        'en': 'Cancel',
    },
};
export function translate(text, locale) {
    if (!localization[text])
        return text;
    return localization[text][locale] ? localization[text][locale] : localization[text].en;
}
